import React, { ReactElement } from "react";
import ValidationItem from "./ValidationItem.component";
import type { GroupedValidations } from "./helpers";
import type { ValidationResponse } from "types/validation";

interface ValidationListProps {
  groupedValidations: GroupedValidations; // typically Record<string, ErrorObject[]>
}

export default function ValidationList({
  groupedValidations,
}: ValidationListProps): ReactElement | null {
  const entries: Array<[string, ValidationResponse[]]> =
    Object.entries(groupedValidations);

  if (entries.length === 0) return null;

  return (
    <>
      {entries.map(([objectId, validations]) =>
        validations && validations.length > 0 ? (
          <ValidationItem key={objectId} validations={validations} />
        ) : null
      )}
    </>
  );
}
